/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'ajs-legacy';
const componentName = 'infrastructure-detail';
const prefix = `${moduleName}.${componentName}`;

export const defaultCloudHeader = `${prefix}.defaultCloudHeader`;
export const selectCloudDropdownLabel = `${prefix}.selectCloudDropdownLabel`;
export const selectCloudDropdownPlaceholder = `${prefix}.selectCloudDropdownPlaceholder`;

export const ENGLISH = {
    [defaultCloudHeader]: 'Default-Cloud',
    [selectCloudDropdownLabel]: 'Select Cloud:',
    [selectCloudDropdownPlaceholder]: 'Select Cloud',
};
